import React from 'react';
import foto from '../assets/FotoJL.jpg';
import { Helmet } from 'react-helmet';




const AcercaDe = () => {
  return (
    <div>
      <Helmet>
        <title>Acerca de</title>
      </Helmet>
      <h1>Acerca de</h1>
      <p>
        D3sarrollo es es una pequeña empresa de desarrollo de paginas web y aplicaciones moviles, ubicada en Quetzaltenango, Guatemala, C.A.
      </p>

      <p>
        ---
      </p>

      <h2>Visión</h2>
      <p>
        Ser la empresa líder en consultoría y desarrollo tecnológico en Guatemala, reconocida por la calidad y la innovación en nuestros proyectos. Buscamos transformar ideas en soluciones tecnológicas que impulsen el crecimiento de las pequeñas y medianas empresas, así como contribuir al desarrollo económico y social del país.
      </p>

      <h2>Misión</h2>
      <p>
        Proveer soluciones tecnológicas de alta calidad que satisfagan las necesidades de nuestros clientes, mediante la integración de tecnologías avanzadas y un enfoque personalizado. Nos comprometemos a ofrecer servicios de consultoría y desarrollo de software que mejoren la eficiencia operativa y fomenten la competitividad, apoyando el crecimiento sostenible y el éxito de nuestros clientes en el ámbito digital.
      </p>

      <p>
        ---
      </p>

      <p>
        Si desea una pagina web o aplicación movil, para su negocio u organización, no dude en contactar con servicio al cliente al telefono (+502) 3566 6969,  de Lunes a Sabado, en horario laboral.
      </p>

      <p></p>
    

    </div>
  );
};

export default AcercaDe;